export default __webpack_public_path__ + "static/media/race-sportsbook-no-goblet-on-dark.bbfcebc9.png";